export const shareInAppTypes = {
  EVENT: "EVENT",
  GROUP: "GROUP"
}
